import { loadStripe } from '@stripe/stripe-js';

// loadStripe must be called once and the promise reused — re-creating it on
// every render reloads Stripe.js and breaks Elements. CRA exposes the
// publishable key (safe to embed client-side) via REACT_APP_*.
const publishableKey = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;

let stripePromise = null;

export const getStripe = () => {
  if (!publishableKey) {
    // Surface the misconfiguration loudly in dev rather than failing silently
    // inside Elements.
    console.error('Missing REACT_APP_STRIPE_PUBLISHABLE_KEY — add it to .env.local.');
    return null;
  }
  if (!stripePromise) {
    stripePromise = loadStripe(publishableKey);
  }
  return stripePromise;
};
